// Shared definition of athletic / combine training metrics.
// lowerBetter: true means a smaller value is a better result (timed drills).
export const TRAINING_FIELDS = [
  { k: "sprint_10yd", l: "10 yd Sprint (s)", lowerBetter: true, color: "#15803D" },
  { k: "sprint_20yd", l: "20 yd Sprint (s)", lowerBetter: true, color: "#FF9500" },
  { k: "sprint_40yd", l: "40 yd Sprint (s)", lowerBetter: true, color: "#007AFF" },
  { k: "shuttle_5_10_5", l: "5-10-5 Shuttle (s)", lowerBetter: true, color: "#34C759" },
  { k: "t_test", l: "T-Test Agility (s)", lowerBetter: true, color: "#15803D" },
  { k: "vertical_jump", l: "Vertical Jump (in)", lowerBetter: false, color: "#007AFF" },
  { k: "broad_jump", l: "Broad Jump (in)", lowerBetter: false, color: "#34C759" },
  { k: "beep_test", l: "Beep Test (level)", lowerBetter: false, color: "#FF9500" },
  { k: "plank_hold", l: "Plank Hold (s)", lowerBetter: false, color: "#007AFF" },
  { k: "max_pushups", l: "Max Push-ups", lowerBetter: false, color: "#15803D" },
];
